var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-20 mb-20",attrs:{"id":"detailInfo","role":"listitem"}},[(_vm.policies)?_c('p',{staticClass:"weight-normal"},[_vm._v(_vm._s(_vm.policies.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }